import type { MentionOptions } from "@tiptap/extension-mention";
import { Mention } from "@tiptap/extension-mention";
import type { NodeType } from "@tiptap/react";
import { mergeAttributes } from "@tiptap/react";
import { MentionComponentAttributeNames } from "./types";
import type { TMentionComponentAttributes, MentionHandler } from "./types";

export type MentionExtensionOptions = MentionOptions & {
  renderComponent: MentionHandler["renderComponent"];
  getMentionedEntityDetails: MentionHandler["getMentionedEntityDetails"];
};

export const CustomMentionExtensionConfig =
  Mention.extend<MentionExtensionOptions>({
    addAttributes() {
      return {
        [MentionComponentAttributeNames.ID]: {
          default: null
        },
        [MentionComponentAttributeNames.EntityIdentifier]: {
          default: null
        },
        [MentionComponentAttributeNames.EntityName]: {
          default: null
        },
        [MentionComponentAttributeNames.Title]: {
          default: null
        }
      };
    },

    parseHTML() {
      return [
        {
          tag: "mention-component"
        }
      ];
    },

    renderHTML({ HTMLAttributes }) {
      return ["mention-component", mergeAttributes(HTMLAttributes)];
    },

    renderText({ node }) {
      return getMentionDisplayText(this.options, node as unknown as NodeType);
    }
  });

const getMentionDisplayText = (
  options: MentionExtensionOptions,
  node: NodeType
): string => {
  const attrs = node.attrs as TMentionComponentAttributes;
  const mentionEntityId =
    attrs[MentionComponentAttributeNames.EntityIdentifier];
  const mentionEntityDetails = options.getMentionedEntityDetails?.(
    mentionEntityId ?? ""
  );

  return `@${mentionEntityDetails?.display_name ?? attrs[MentionComponentAttributeNames.Title] ?? attrs[MentionComponentAttributeNames.ID] ?? mentionEntityId}`;
};
